import script from "./SpaceSceneViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./SpaceSceneViewer.vue?vue&type=script&setup=true&lang=js"

import "./SpaceSceneViewer.vue?vue&type=style&index=0&id=e5bb56fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5bb56fa"]])

export default __exports__